var _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#feedback_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 32,
    fill: "#5E88EF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.627 54.44.52 4.213c.133 1.107-1.054 1.88-2 1.307l-5.587-3.32c-.613 0-1.213-.04-1.8-.12.987-1.16 1.573-2.627 1.573-4.213 0-3.787-3.28-6.854-7.333-6.854-1.547 0-2.973.44-4.16 1.214a8.451 8.451 0 0 1-.053-1.014c0-6.066 5.266-10.986 11.773-10.986s11.773 4.92 11.773 10.986c0 3.6-1.853 6.787-4.706 8.787Z",
    stroke: "#FBFCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.333 52.307c0 1.586-.586 3.053-1.573 4.213-1.32 1.6-3.413 2.627-5.76 2.627l-3.48 2.066c-.587.36-1.333-.133-1.253-.813l.333-2.627c-1.787-1.24-2.933-3.226-2.933-5.466 0-2.347 1.253-4.414 3.173-5.64A7.577 7.577 0 0 1 42 45.453c4.053 0 7.333 3.067 7.333 6.854Z",
    stroke: "#FBFCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "feedback_svg__a",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1482_27894"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1482_27894",
    result: "shape"
  })))));
};

export { SvgFeedback as ReactComponent };
export default __webpack_public_path__ + "static/media/feedback.1a8d1112.svg";